export const CONVERSATIONS_QUERY = /* GraphQL */ `
  query Conversations {
    conversations {
      id name isGroup unreadCount updatedAt
      participants {
        id
        user { id name givenName familyName picture }
        lastReadAt joinedAt
      }
      lastMessage {
        id content createdAt
        author { id name givenName familyName picture }
        attachments { id originalName url fileSize mimeType }
      }
    }
  }
`;

export const MESSAGES_QUERY = /* GraphQL */ `
  query Messages($conversationId: ID!, $cursor: String, $limit: Int) {
    messages(conversationId: $conversationId, cursor: $cursor, limit: $limit) {
      id conversationId content createdAt
      author { id name givenName familyName picture }
      attachments { id originalName url fileSize mimeType }
      linkUrl linkTitle linkDescription linkImageUrl linkDomain
      readBy { id user { id } lastReadAt }
    }
  }
`;

export const CONNECTIONS_FOR_CHAT_QUERY = /* GraphQL */ `
  query ChatContacts {
    chatContacts {
      id
      user { id name givenName familyName picture }
    }
  }
`;

export const CREATE_OR_GET_CONVERSATION = /* GraphQL */ `
  mutation CreateOrGetConversation($participantIds: [ID!]!, $name: String) {
    createOrGetConversation(participantIds: $participantIds, name: $name) {
      id name isGroup updatedAt unreadCount
      participants {
        id
        user { id name givenName familyName picture }
        lastReadAt joinedAt
      }
      lastMessage {
        id content createdAt
        author { id name givenName familyName picture }
      }
    }
  }
`;

export const SEND_MESSAGE = /* GraphQL */ `
  mutation SendChatMessage($conversationId: ID!, $content: String!, $attachments: [MessageAttachmentInput!]) {
    sendChatMessage(conversationId: $conversationId, content: $content, attachments: $attachments) {
      id conversationId content createdAt
      author { id name givenName familyName picture }
      attachments { id originalName url fileSize mimeType }
      linkUrl linkTitle linkDescription linkImageUrl linkDomain
      readBy { id user { id } lastReadAt }
    }
  }
`;

export const UPLOAD_ATTACHMENT = /* GraphQL */ `
  mutation UploadMessageAttachment($fileName: String!, $mimeType: String!, $data: String!, $fileSize: Int!) {
    uploadMessageAttachment(fileName: $fileName, mimeType: $mimeType, data: $data, fileSize: $fileSize) {
      originalName url fileSize mimeType
    }
  }
`;

export const MARK_READ = /* GraphQL */ `
  mutation MarkConversationRead($conversationId: ID!) {
    markConversationRead(conversationId: $conversationId)
  }
`;

export const UPDATE_CONVERSATION_NAME = /* GraphQL */ `
  mutation UpdateConversationName($conversationId: ID!, $name: String!) {
    updateConversationName(conversationId: $conversationId, name: $name) {
      id name
    }
  }
`;

export const SET_TYPING = /* GraphQL */ `
  mutation SetTypingStatus($conversationId: ID!, $isTyping: Boolean!) {
    setTypingStatus(conversationId: $conversationId, isTyping: $isTyping)
  }
`;

export const MESSAGE_ADDED_SUB = /* GraphQL */ `
  subscription OnMessageAdded($conversationId: ID!) {
    onMessageAdded(conversationId: $conversationId) {
      id conversationId content createdAt
      author { id name givenName familyName picture }
      attachments { id originalName url fileSize mimeType }
      linkUrl linkTitle linkDescription linkImageUrl linkDomain
      readBy { id user { id } lastReadAt }
    }
  }
`;

export const CONV_UPDATED_SUB = /* GraphQL */ `
  subscription OnConversationUpdated {
    onConversationUpdated {
      id name isGroup unreadCount updatedAt
      participants {
        id
        user { id name givenName familyName picture }
        lastReadAt joinedAt
      }
      lastMessage {
        id content createdAt
        author { id name givenName familyName picture }
        attachments { id originalName url fileSize mimeType }
      }
    }
  }
`;

export const TYPING_SUB = /* GraphQL */ `
  subscription OnTypingStatus($conversationId: ID!) {
    onTypingStatus(conversationId: $conversationId) {
      conversationId
      isTyping
      user { id name givenName familyName }
    }
  }
`;
